const HORAS = [
  'doce', 'una', 'dos', 'tres', 'cuatro', 'cinco', 'seis',
  'siete', 'ocho', 'nueve', 'diez', 'once', 'doce'
];

function convertirHora(hStr, mStr) {
  let h = parseInt(hStr, 10);
  const m = parseInt(mStr, 10);

  // Convertir a 12h
  h = h % 12; // 0→0, 12→0, 13→1, etc.

  // Minuto 45: "menos cuarto" sube la hora
  let horaFinal = m === 45 ? (h + 1) % 12 : h;
  const nombreHora = HORAS[horaFinal];
  const articulo = horaFinal === 1 ? 'la' : 'las';

  let resultado = `${articulo} ${nombreHora}`;

  if (m === 0) {
    // sin sufijo, suena más natural
  } else if (m === 15) {
    resultado += ' y cuarto';
  } else if (m === 30) {
    resultado += ' y media';
  } else if (m === 45) {
    resultado += ' menos cuarto';
  } else {
    const decenas = Math.floor(m / 10);
    const unidades = m % 10;
    const palabrasMinutos = [
      '', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve',
      'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete',
      'dieciocho', 'diecinueve', 'veinte', 'veintiuno', 'veintidós', 'veintitrés',
      'veinticuatro', 'veinticinco', 'veintiséis', 'veintisiete', 'veintiocho',
      'veintinueve', 'treinta', 'treinta y uno', 'treinta y dos', 'treinta y tres',
      'treinta y cuatro', 'treinta y cinco', 'treinta y seis', 'treinta y siete',
      'treinta y ocho', 'treinta y nueve', 'cuarenta', 'cuarenta y uno', 'cuarenta y dos',
      'cuarenta y tres', 'cuarenta y cuatro', 'cuarenta y cinco', 'cuarenta y seis',
      'cuarenta y siete', 'cuarenta y ocho', 'cuarenta y nueve', 'cincuenta',
      'cincuenta y uno', 'cincuenta y dos', 'cincuenta y tres', 'cincuenta y cuatro',
      'cincuenta y cinco', 'cincuenta y seis', 'cincuenta y siete', 'cincuenta y ocho',
      'cincuenta y nueve'
    ];
    resultado += ` y ${palabrasMinutos[m] || m}`;
  }

  return resultado;
}

export function naturalizeTime(text) {
  // Reemplaza patrones como "13:30horas", "13:30 horas", "13:30" por la forma natural
  return text.replace(/\b(\d{1,2}):(\d{2})\s*horas?\b/g, (_, h, m) => convertirHora(h, m))
             .replace(/\b(\d{1,2}):(\d{2})\b/g, (_, h, m) => convertirHora(h, m));
}
